/**
 * @file:  JS freight菜单接口汇总
 * @author: v_chengmengya
 * @date: 2019-05-21
 * @description: 封装axios
 * @add: carTrainsDetailCity/carTrainsDetailPie 途经各省运营次数详情 chengmengya 2019-05-21 OK
 * @add: carUnpetrifiedCom 停靠非石化加油站企业列表 chengmengya 2019-05-21 OK
 * @add: carOpeDetail chengmengya 2019-05-22
 * @add: carUnpetrifiedCom chengmengya 2019-05-22
 * @add: carOpeDetailExport chengmengya 2019-05-22 高速公路详情导出
 */
import axios from '@/utils/axiosInt.js'

export default {
    //办卡量
    carOperate(option) {
        //高速加油站停靠 高速运营时段
        return axios.post(
            '/bi-api/truckOperate/info?time=' + new Date() * 1,
            option
        )
    },
    operateStatistics(option) {
        //高速加油站停靠 高速运营时段
        return axios.post(
            '/bi-api/roadOperationStatistics/highway/operateStatistics?time=' + new Date() * 1,
            option
        )
    },
    nationalO(option) {
        //高速加油站停靠 高速运营时段
        return axios.post(
            '/bi-api/roadOperationStatistics/national/operateStatistics?time=' + new Date() * 1,
            option
        )
    },
    operateStatisticsW(option) {
        //高速加油站停靠 高速运营时段
        return axios.post(
            '/bi-api/roadOperationStatisticsW/highway/operateStatisticsW?time=' + new Date() * 1,
            option
        )
    },
    nationalOW(option) {
        //高速加油站停靠 高速运营时段
        return axios.post(
            '/bi-api/roadOperationStatisticsW/national/operateStatisticsW?time=' + new Date() * 1,
            option
        )
    },
    operateStopDetail(option) {
        //高速加油站停靠 高速运营时段
        return axios.post(
            '/bi-api/roadOperationStatistics/operateStopDetail?time=' + new Date() * 1,
            option
        )
    },
    operateStopDetailW(option) {
        //高速加油站停靠 高速运营时段
        return axios.post(
            '/bi-api/roadOperationStatisticsW/operateStopDetailW?time=' + new Date() * 1,
            option
        )
    },
    cbCardFindPage(option) {
        //高速加油站停靠 高速运营时段
        return axios.post(
            '/bi-api/customers/cbCard/findPage',
            option
        )
    },
    cbCardFindPage2(option) {
        //高速加油站停靠 高速运营时段
        return axios.post(
            '/bi-api/oilStationBerthCountV2/wayProvinceOilStatistics',
            option
        )
    },
    cbCardFindPage3(option) {
        //高速加油站停靠 高速运营时段
        return axios.post(
            '/bi-api/oilStationBerthCountV2/wayProvinceOilStatisticsW',
            option
        )
    },
    countyStatistics(option) {
        //高速加油站停靠 高速运营时段
        return axios.post(
            '/bi-api/oilStationBerthCountV2/countyStatistics',
            option
        )
    },
    countyStatistics2(option) {
        //高速加油站停靠 高速运营时段
        return axios.post(
            '/bi-api/oilStationBerthCountV2/countyStatisticsW',
            option
        )
    },
    oilStationBerthCountV2(option) {
        //高速加油站停靠 高速运营时段
        return axios.post(
            '/bi-api/oilStationBerthCountV2/provinceStatistics',
            option
        )
    },
    provinceStatisticsW(option) {
        //高速加油站停靠 高速运营时段
        return axios.post(
            '/bi-api/oilStationBerthCountV2/provinceStatisticsW',
            option
        )
    },
    getCountyAreaList({code, areaType, type}) {
        //高速加油站停靠 高速运营时段
        return axios.get(
            `/bi-api/getCountyAreaList?code=${code}&areaType=${areaType}&type=${type}&time=` + new Date() * 1,
        )
    },
    getCountyAreaListBySearch({keyword}) {
        //高速加油站停靠 高速运营时段
        return axios.get(
            `/bi-api/getCountyAreaListBySearch?keyword=${keyword}&time=` + new Date() * 1,
        )
    },
    carGas(option) {
        // 加油站
        return axios.post('/bi-api/truckOil/info?time=' + new Date() * 1, option)
    },
    carLogis(option) {
        // 物流园
        return axios.post('/bi-api/truckWulliu/info?time=' + new Date() * 1, option)
    },
    truckWuliuV2(option) {
        // 物流园
        return axios.post('/bi-api/truckWuliuV2/info?time=' + new Date() * 1, option)
    },
    truckWuliuV2Week(option) {
        // 物流园
        return axios.post('/bi-api/truckWuliuV2/infoW?time=' + new Date() * 1, option)
    },
    wayRoadDecrypt({id}) {
        return axios.post(`/bi-api/wayRoad/decrypt?id=${id}`)
    },
    carTonnageAll({year, month, type, energyType = ''}) {
        // 入网车辆吨位tab数据
        return axios.get(
            `/bi-api/freightVehicleCount/queryRegistVehicle?year=${year}&month=${month}&type=${type}&energyType=${energyType}&time=` +
            new Date() * 1
        )
    },
    carTonnage({
                   condition = 'registSubtotal', energyType = '', registYear,
                   registMonth, type = '', firstPageLoad = ''
               }) {
        // 入网车辆吨位地图数据
        return axios.get(
            `/bi-api/freightVehicleCount/freightProvinceConditions?condition=${condition}&registYear=${registYear}&registMonth=${registMonth}&energyType=${energyType}&type=${type}&firstPageLoad=${firstPageLoad}&time=${new Date() *
            1}`
        )
    },
    // carOperateTon({
    //                 condition = 'operatorSubtotal',
    //                 registYear,
    //                 registMonth,
    //                 energyType = '',
    //                 type = '',
    //                 firstPageLoad = ''
    //               }) {
    //   // 运营车辆吨位地图数据
    //   return axios.get(
    //       `/bi-api/freightVehicleCount/freightProvinceConditions?condition=${condition}&registYear=${registYear}&registMonth=${registMonth}&energyType=${energyType}&type=${type}&firstPageLoad=${firstPageLoad}&time=${new Date() *
    //       1}`
    //   )
    // },
    carTonnageExport({reqId, yearMonths, type = ''}) {
        return `/bi-api/freightVehicleCount/registVehicleExport?yearMonths=${yearMonths}&type=${type}&reqId=${reqId}`
    },
    carOperateTonAll({year, month, energyType = '', type = ''}) {
        // 运营车辆吨位分布tab数据
        return axios.get(
            `/bi-api/freightVehicleCount/queryOperatorVehicle?year=${year}&month=${month}&energyType=${energyType}&type=${type}&time=` +
            new Date() * 1
        )
    },
    carOperateTon({
                      condition = 'operatorSubtotal',
                      registYear,
                      registMonth,
                      energyType = '',
                      type = '',
                      firstPageLoad = ''
                  }) {
        // 运营车辆吨位地图数据
        return axios.get(
            `/bi-api/freightVehicleCount/freightProvinceConditions?condition=${condition}&registYear=${registYear}&registMonth=${registMonth}&energyType=${energyType}&type=${type}&firstPageLoad=${firstPageLoad}&time=${new Date() *
            1}`
        )
    },
    carOpeDetail({roadCode, year, month, type, moduleType}) {
        // 重点道路运营详情数据
        return axios.get(
            `/bi-api/motorwayVehicleDistribute/roadBywayProvinceStatic?moduleType=${moduleType}&roadCode=${roadCode}&year=${year}&month=${month}&type=${type}&time=${new Date() *
            1}`
        )
    },
    carOpeDetailExport({roadCode, yearMonths, type, reqId, moduleType}) {
        // 重点道路详情导出
        return `/bi-api/motorwayVehicleDistribute/motorwayOperatorVehicleExport?moduleType=${moduleType}&roadCode=${roadCode}&yearMonths=${yearMonths}&type=${type}&reqId=${reqId}`
    },
    carOperateTonExport({reqId, registYear, registMonth, type}) {
        return `/bi-api/freightVehicleCount/operatorVehicleExport?registYear=${registYear}&registMonth=${registMonth}&reqId=${reqId}&type=${type}`
    },
    carMilengeAll({year, month, energyType = '', type = ''}) {
        // 运营车辆行驶里程分布Tab切换
        return axios.get(
            `/bi-api/freightVehicleCount/queryOperatorMileage?year=${year}&month=${month}&energyType=${energyType}&type=${type}&time=` +
            new Date() * 1
        )
    },
    carMilenge({
                   condition = 'mileageSubtotal',
                   registYear,
                   registMonth,
                   energyType = '',
                   type = '',
                   firstPageLoad = ''
               }) {
        // 运营车辆行驶里程地图数据
        return axios.get(
            `/bi-api/freightVehicleCount/freightProvinceConditions?condition=${condition}&energyType=${energyType}&type=${type}&registYear=${registYear}&registMonth=${registMonth}&firstPageLoad=${firstPageLoad}&time=${new Date() *
            1}`
        )
    },
    carMilengeExport({reqId, registYear, registMonth, type}) {
        return `/bi-api/freightVehicleCount/operatorMileageExport?registYear=${registYear}&registMonth=${registMonth}&reqId=${reqId}&type=${type}`
    },
    carTimeAll({year, month, energyType = '', type = ''}) {
        // 运营车辆运营时间分布Tab切换
        return axios.get(
            `/bi-api/freightVehicleCount/queryOperatorTime?year=${year}&month=${month}&energyType=${energyType}&type=${type}&time=` +
            new Date() * 1
        )
    },
    carTime({
                condition = 'timeSubtotal',
                registYear,
                registMonth,
                energyType = '',
                type = '',
                firstPageLoad = ''
            }) {
        // 运营车辆运营时间地图数据
        return axios.get(
            `/bi-api/freightVehicleCount/freightProvinceConditions?condition=${condition}&registYear=${registYear}&registMonth=${registMonth}&energyType=${energyType}&type=${type}&firstPageLoad=${firstPageLoad}&time=${new Date() *
            1}`
        )
    },
    carTimeExport({reqId, registYear, registMonth, type}) {
        return `/bi-api/freightVehicleCount/operatorTimeExport?registYear=${registYear}&registMonth=${registMonth}&reqId=${reqId}&type=${type}`
    },
    carTrains(option) {
        // 途径各省运营车次数统计
        return axios.post(
            '/bi-api/vehicleway/getTotal?time=' + new Date() * 1,
            option
        )
    },
    carTrainsDetailCity(option) {
        // 途经各省运营次数详情 城市列表
        return axios.post(
            '/bi-api/vehicleway/cityList?time=' + new Date() * 1,
            option
        )
    },
    carTrainsDetailPie({
                           pathWayCityCode,
                           year,
                           month,
                           dataType,
                           timeType,
                           fuelType
                       }) {
        // 途经各省运营次数详情 柱状图
        return axios.get(
            `/bi-api/vehicleWayCityCount/byWayCityVehicleCount?pathWayCityCode=${pathWayCityCode}&year=${year}&month=${month}&dataType=${dataType}&timeType=${timeType}&fuelType=${fuelType}&time=` +
            new Date() * 1
        )
    },
    carTrainsDetailExport({time, provinceName, reqId, timeType, dataType}) {
        return (
            `/bi-api/vehicleWayCityCount/byWayCityVehicleCountExport?reqId=${reqId}&yearMonths=${time}&timeType=${timeType}&dataType=${dataType}&provinceName=` +
            encodeURIComponent(provinceName)
        )
    },
    // getProList(option) {
    //   // 途径各省运营车次数统计
    //   return axios.post(
    //     '/bi-api/vehicleway/proList?time=' + new Date() * 1,
    //     option
    //   )
    // },
    carUnpetrifiedCom(option) {
        return axios.post(
            '/bi-api/hYCompanyDetail/info?time=' + new Date() * 1,
            option
        )
    },
    customersAll(option) {
        return axios.post(
            '/bi-api/customers/all/findPage?time=' + new Date() * 1,
            option
        )
    },
    receiveTask(option) {
        return axios.post(
            '/bi-api/customers/all/receive?time=' + new Date() * 1,
            option
        )
    },
    cancelReceive(option) {
        return axios.post(
            '/bi-api/customers/target/cancelReceive?time=' + new Date() * 1,
            option
        )
    },
    devComplete(option) {
        return axios.post(
            '/bi-api/customers/target/devComplete?time=' + new Date() * 1,
            option
        )
    },
    updateCardInfo(option) {
        return axios.post(
            '/bi-api/customers/target/updateCardInfo?time=' + new Date() * 1,
            option
        )
    },
    cardInfoAll(option) {
        return axios.post(
            '/bi-api/customers/all/cardInfo?time=' + new Date() * 1,
            option
        )
    },
    completeInfoTar(option) {
        return axios.post(
            '/bi-api/customers/target/completeInfo?time=' + new Date() * 1,
            option
        )
    },
    commonCardListAll(option) {
        return axios.post(
            '/bi-api/customers/target/commonCardList?time=' + new Date() * 1,
            option
        )
    },
    targetFindPage(option) {
        return axios.post(
            '/bi-api/customers/target/findPage?time=' + new Date() * 1,
            option
        )
    },
    batchCancelReceiveImpact(option) {
        return axios.post(
            '/bi-api/customers/target/batchCancelReceiveImpact?time=' + new Date() * 1,
            option
        )
    },
    batchCancelReceive(option) {
        return axios.post(
            '/bi-api/customers/target/batchCancelReceive?time=' + new Date() * 1,
            option
        )
    },
    cancelReceiveLogFindPage(option) {
        return axios.post(
            '/bi-api/customers/cancelReceiveLog/findPage?time=' + new Date() * 1,
            option
        )
    },
    gasStationInfo(option) {
        return axios.post(
            '/bi-api/customers/gasStationInfo?time=' + new Date() * 1,
            option
        )
    },
    devRecordInfo(option) {
        return axios.post(
            '/bi-api/customers/devRecordInfo?time=' + new Date() * 1,
            option
        )
    },
    manageRecordInfo(option) {
        return axios.post(
            '/bi-api/customers/manageRecordInfo?time=' + new Date() * 1,
            option
        )
    },
    carUnpetrifiedDetail(option) {
        return axios.post(
            '/bi-api/hYCompanyDetail/vehicle?time=' + new Date() * 1,
            option
        )
    },
    carUnpetrifiedComProv(option) {
        return axios.get(
            '/bi-api/oilStationBerthCount/getProvinces?time=' + new Date() * 1,
            option
        )
    },
    carUnpetrifiedComProv(option) {
        return axios.get(
            '/bi-api/oilStationBerthCount/getProvinces?time=' + new Date() * 1,
            option
        )
    },
    getProList({phone}) {
        return axios.get(
            `/bi-api/vehicleway/proList?phone=${phone}&_=${new Date() * 1}`
        )
    },
    carTrainsDown: function ({time, reqId, dataType, timeType}) {
        return `/bi-api/vehicleway/export?time=${time}&dataType=${dataType}&timeType=${timeType}&reqId=${reqId}`
    },
    progress({reqId}) {
        return axios.get(
            `/bi-api/export/getProgress?reqId=${reqId}&_=${new Date() * 1}`
        )
    },
    carOperateDown({
                       // 高速下载
                       countTime,
                       reqId,
                       type,
                       moduleType
                   }) {
        return `/bi-api/truckOperate/exportTruck?countTime=${countTime}&type=${type}&moduleType=${moduleType}&reqId=${reqId}`
    },
    operateStatisticsExport({
                                // 高速下载
                                countTime,
                                reqId,
                                type,
                                moduleType,
                                roadType,
                                provCityCounty,
                                sourceGastype
                            ,provCodes,
                            cityCodes,
                            countyCodes,
                                dateType
                            }) {
        let item = countTime.split('-')
        return `/bi-api/roadOperationStatistics/highway/operateStatisticsExport?countTime=${countTime}&dateType=${dateType}&provCodes=${provCodes || ''}&cityCodes=${cityCodes || ''}&countyCodes=${countyCodes || ''}&sourceGastype=${sourceGastype}&provincecode=${provCityCounty?provCityCounty[0]:'' || ''}&citycode=${provCityCounty?provCityCounty[1]:'' || ''}&countycode=${provCityCounty?provCityCounty[2]:'' || ''}&year=${item[0]}&month=${item[1]}&roadType=${roadType}&moduleType=${moduleType}&reqId=${reqId}`
    },
    addEnergyExport({
                        // 高速下载
                        countTime,
                        reqId,
                        type,
                        moduleType,
                        provCityCounty,
                        roadType,
                        sourceGastype
                    ,provCodes,
                    cityCodes,
                    countyCodes,
                        dateType
                    }) {
        let item = countTime.split('-')
        return `/bi-api/roadOperationStatistics/highway/addEnergyExport?countTime=${countTime}&dateType=${dateType}&provCodes=${provCodes || ''}&cityCodes=${cityCodes || ''}&countyCodes=${countyCodes || ''}&sourceGastype=${sourceGastype}&provincecode=${provCityCounty?provCityCounty[0]:'' || ''}&citycode=${provCityCounty?provCityCounty[1]:'' || ''}&countycode=${provCityCounty?provCityCounty[2]:'' || ''}&year=${item[0]}&month=${item[1]}&roadType=${roadType}&moduleType=${moduleType}&reqId=${reqId}`
    },
    addEnergyStopInfoExport({
                                // 高速下载
                                countTime,
                                reqId,
                                type,
                                moduleType,
                                provCityCounty,
                                roadType,
                                sourceGastype,
                            provCodes,
                            cityCodes,
                            countyCodes,
                                dateType
                            }) {
        let item = countTime.split('-')
        return `/bi-api/roadOperationStatistics/addEnergyStopInfoExport?countTime=${countTime}&dateType=${dateType}&provCodes=${provCodes || ''}&cityCodes=${cityCodes || ''}&countyCodes=${countyCodes || ''}&sourceGastype=${sourceGastype}&provincecode=${provCityCounty?provCityCounty[0]:'' || ''}&citycode=${provCityCounty?provCityCounty[1]:'' || ''}&countycode=${provCityCounty?provCityCounty[2]:'' || ''}&year=${item[0]}&month=${item[1]}&roadType=${roadType}&moduleType=${moduleType}&reqId=${reqId}`
    },
    carGasDown({
                   // 加油站下载
                   countTime,
                   reqId
               }) {
        return `/bi-api/truckOil/exportTruck?countTime=${countTime}&reqId=${reqId}`
    },

    // 物流园停靠统计top100
    carLogiDetal({poiId, year, month}) {
        return axios.get(
            `/bi-api//truckWulliu/topCompany?poiId=${poiId}&year=${year}&month=${month}`
        )
    },
    carLogiDetal2({poiId, year, month, sourceGastype}) {
        return axios.get(
            `/bi-api//truckWuliuV2/topCompany?poiId=${poiId}&year=${year}&month=${month}&sourceGastype=${sourceGastype?sourceGastype:''}`
        )
    },
    // 物流园停靠统计查询月top100
    carLogiDetalMonth({moduleName, year, provinceCode, provinceName, region, brand, pathwayCityCode, roadCode}) {
        return axios.get(
            `/bi-api/exportDiscern/exportFreightDiscern?moduleName=${moduleName}&year=${year}&provinceCode=${provinceCode}&provinceName=${provinceName}&region=${region}&brand=${brand}&pathwayCityCode=${pathwayCityCode}&roadCode=${roadCode}`
        )
    },
    // /truckWulliu/decrypt
    // 物流园停靠统计top100公司解密
    carLogiDetalDecrypt({id}) {
        return axios.get(`/bi-api//truckWulliu/decrypt?id=${id}`)
    },
    carLogiDetalDecrypt2({id}) {
        return axios.get(`/bi-api//truckWuliuV2/decrypt?id=${id}`)
    },
    carLogisDown({
                     // 物流园下载
                     dateType,
                     countTime,
                     reqId,
                     provinceCode,
                     cityCode
                 }) {
        return (
            `/bi-api/truckWulliu/exportTruck?countTime=${countTime}&reqId=${reqId}&dateType=${dateType}&provinceCode=` +
            encodeURIComponent(provinceCode) +
            `&cityCode=` +
            encodeURIComponent(cityCode)
        )
    },
    carGasStation({year, Month, poiType, firstRequest}) {
        // 月均加油站停靠占比统计
        return axios.get(
            `/bi-api/vehiclePoiStopRatio/stopProvinceStation?year=${year}&Month=${Month}&poiType=` +
            encodeURIComponent(poiType) +
            `&firstRequest=${firstRequest}`
        )
    },
    stopProvinceStationExport({reqId, year, month}) {
        return `/bi-api/vehiclePoiStopRatio/stopProvinceStationExport?reqId=${reqId}&_=${new Date() *
        1}&year=${year}&month=${month}`
    },
    carProvinceMileage(option) {
        // 途径各省加油站/里程
        return axios.post('/bi-api/wayRoad/getTotal?time=' + new Date() * 1, option)
    },
    carProvinceMileageV2_getMiles({dateType, range, fuelType}) {
        // 途经各省道路里程统计
        return axios.post(
            `/bi-api/wayRoad/getMiles?dateType=${dateType}&range=${range}&fuelType=${fuelType}`
        )
    },
    carProvinceMileageV2_getMiles_top100(option) {
        // 途经各省道路里程统计-二级页
        return axios.post(`/bi-api/wayRoad/provinceTop`, option)
    },
    carProvinceMileageV2_getGasStationStat({dateType, range, fuelType}) {
        // 停靠各省道路加油站次数统计
        return axios.post(
            `/bi-api/wayRoad/getGasStationStat?dateType=${dateType}&range=${range}&fuelType=${fuelType}`
        )
    },
    carProvinceMileageV2_getGasStationStat_stopInfoByRoad({
                                                              dateType,
                                                              range,
                                                              provinceCode
                                                          }) {
        // 停靠各省道路加油站次数统计
        return axios.post(
            `/bi-api/wayRoad/stopInfoByRoad?dateType=${dateType}&range=${range}&provinceCode=${provinceCode}`
        )
    },
    wayRoadExport({reqId, dateType, yearMonths, type}) {
        return `/bi-api/wayRoad/export?reqId=${reqId}&_=${new Date() *
        1}&time=${yearMonths}&type=${type}`
    },
    wayRoadExportV2({reqId, dateType, yearMonths, type}) {
        let url = `/bi-api/wayRoad/export2?reqId=${reqId}&dateType=${dateType}&range=${yearMonths}&type=${type}&_=${new Date() *
        1}`
        console.log('wayRoadExportV2', url)
        return url
    },
    wayRoadExportV2Tab2Detail({reqId, dateType, range, provinceCode}) {
        let url = `/bi-api/wayRoad/stopInfoByRoadExport?reqId=${reqId}&dateType=${dateType}&range=${range}&provinceCode=${provinceCode}&_=${new Date() *
        1}`
        console.log('wayRoadExportV2Tab2Detail', url)
        return url
    },
    // 运营吨位分布批量导出
    operatorVehicleExport: function ({yearMonths, reqId, type = ''}) {
        return `/bi-api/freightVehicleCount/operatorVehicleExport?yearMonths=${yearMonths}&reqId=${reqId}&type=${type}`
    },
    // 运营里程分布批量导出
    operatorMileageExport: function ({yearMonths, reqId, type}) {
        return `/bi-api/freightVehicleCount/operatorMileageExport?yearMonths=${yearMonths}&reqId=${reqId}&type=${type}`
    },
    // 运营时间分布批量导出
    operatorTimeExport: function ({yearMonths, reqId}) {
        return `/bi-api/freightVehicleCount/operatorTimeExport?yearMonths=${yearMonths}&reqId=${reqId}`
    },
    // 月均停靠加油站占比数据批量导出
    stopProvinceStationExport: function ({yearMonths, reqId}) {
        return `/bi-api/vehiclePoiStopRatio/stopProvinceStationExport?yearMonths=${yearMonths}&reqId=${reqId}`
    },
    // 车辆途经各省份品牌加油站停靠次数导出
    vehiclStationExprot: function ({yearMonths, reqId, timeType}) {
        return `/bi-api/vehiclStation/exportProvince?time=${yearMonths}&reqId=${reqId}&timeType=${timeType}`
    },
    oilStationBerthCountV2Ex: function ({yearMonths, reqId, timeType, sourceGastype,dateType}) {
        return `/bi-api/oilStationBerthCountV2/exportProvince?time=${yearMonths}&sourceGastype=${sourceGastype}&dateType=${dateType}&reqId=${reqId}&timeType=${timeType}`
    },
    oilStationBerthCountyV2Ex: function ({yearMonths, reqId, timeType,provCode, cityCode, countyCode, provCodes, cityCodes, countyCodes, sourceGastype,dateType}) {
        return `/bi-api/oilStationBerthCountV2/exportCounty?time=${yearMonths}&reqId=${reqId}&dateType=${dateType}&provCodes=${provCodes}&cityCodes=${cityCodes}&countyCodes=${countyCodes}&provCode=${provCode}&cityCode=${cityCode}&countyCode=${countyCode}&sourceGastype=${sourceGastype}&timeType=${timeType}`
    },
    oilStationBerthDetailV2Ex: function ({yearMonths, reqId, timeType, provCode, cityCode, countyCode,provCodes, cityCodes, countyCodes, sourceGastype,dateType}) {
        return `/bi-api/oilStationBerthCountV2/exportOilStationBerth?time=${yearMonths}&reqId=${reqId}&dateType=${dateType}&provCode=${provCode}&cityCode=${cityCode}&countyCode=${countyCode}&provCodes=${provCodes}&cityCodes=${cityCodes}&countyCodes=${countyCodes}&sourceGastype=${sourceGastype}&timeType=${timeType}`
    },
    oilStationWayProvinceV2Ex: function ({yearMonths, reqId, timeType, provCode, sourceGastype,dateType}) {
        return `/bi-api/oilStationBerthCountV2/exportWayProvince?time=${yearMonths}&reqId=${reqId}&dateType=${dateType}&provCode=${provCode}&sourceGastype=${sourceGastype}&timeType=${timeType}`
    },
    // 车辆途经各省份品牌加油站停靠次数导出
    exportCityExport: function ({yearMonths, reqId, pathwayProvcode, timeType}) {
        return `/bi-api/vehiclStation/pathwayExportCity?time=${yearMonths}&reqId=${reqId}&pathwayProvcode=${pathwayProvcode}&timeType=${timeType}`
    },
    // 入网车辆吨位，运营车辆吨位，里程，运营时间 城市  导出
    exportMoreData: function ({
                                  yearMonths,
                                  reqId,
                                  province,
                                  provinCode,
                                  condition,
                                  type
                              }) {
        return (
            `/bi-api/freightVehicleCity/exportRegistSub?countTime=${yearMonths}&reqId=${reqId}&province=` +
            encodeURIComponent(province) +
            `&provinCode=${provinCode}&condition=${condition}&type=${type}`
        )
    },
    // 物流园统计导出
    exportTruck: function ({
                               yearMonths,
                               reqId,
                               provCodes,
                               cityCodes,
                               countyCodes,
                               provCode,
                               cityCode,
                               countyCode,
                               tonnages,
                               type
                           }) {
        return (
            `/bi-api/truckWuliuV2/exportTruck?countTime=${yearMonths}&reqId=${reqId}&provCodes=${provCodes}&cityCodes=${cityCodes}&countyCodes=${countyCodes}&provCode=${provCode}&cityCode=${cityCode}&countyCode=${countyCode}&type=${type}`
        )
    },
    // 获取用户权限内所有省份列表
    getProvinces() {
        return axios.get(
            `/bi-api/oilStationBerthCount/getProvinces?_=${new Date() * 1}`
        )
    },
    // 车辆途经省份品牌加油站停靠次数统计:
    getBrandList({yearMonth, proCode, type, countryIs, timeType}) {
        return axios.get(
            `/bi-api/oilStationBerthCount/vehicleByWayProvinceOilStaticCount?yearMonth=${yearMonth}&proCode=${proCode}&type=${type}&countryIs=${countryIs}&timeType=${timeType} `
        )
    },
    //车辆途经地市品牌加油站停靠数据统计:
    getCityBrandList({
                         yearTime,
                         pathwayProvcode,
                         monthTime,
                         page,
                         pageSize,
                         timeType
                     }) {
        return axios.get(
            `/bi-api/oilStationBerthCount/vehicleByWayProvinceOilStaticCityCount?yearTime=${yearTime}&pathwayProvcode=${pathwayProvcode}&monthTime=${monthTime}&page=${page}&pageSize=${pageSize}&timeType=${timeType}`
        )
    },
    //加油站停靠统计 -- 油站明细:
    getDetailsList({
                       countTime,
                       provinceName,
                       cityName,
                       oilBrand,
                       page,
                       pageSize,
                       timeType
                   }) {
        return axios.get(
            `/bi-api/oilStationBerthCount/oilStationBerth?countTime=${countTime}&provinceName=` +
            encodeURIComponent(provinceName) +
            `&cityName=` +
            encodeURIComponent(cityName) +
            `&oilBrand=${oilBrand}&page=${page}&pageSize=${pageSize}&timeType=${timeType}`
        )
    },
    getDetailsList2(option) {
        return axios.post(
            `/bi-api/oilStationBerthCountV2/oilStationBerth`, option
        )
    },
    getDetailsList3(option) {
        return axios.post(
            `/bi-api/oilStationBerthCountV2/oilStationBerthW`, option
        )
    },
    //加油站停靠统计 -- 油站明细 -- 油站停靠次数top100企业
    getStopDetailTop100Company({
                                   poiId,
                                   year,
                                   month,
                               }) {
        return axios.get(
            `/bi-api/oilStationBerthCount/topCompany?poiId=${poiId}&year=${year}&month=${month}`
        )
    },
    //加油站停靠统计 -- 油站明细 -- 油站停靠次数top100企业
    getStopDetailTop100Company2({
                                    poiId,
                                    year,
                                    month,
                                    sourceGastype,
                                }) {
        return axios.get(
            `/bi-api/oilStationBerthCountV2/topCompany?poiId=${poiId}&year=${year}&month=${month}&sourceGastype=${sourceGastype}`
        )
    },
    //加油站停靠统计 -- 油站明细 -- 油站停靠次数top100企业 -- 企业解密
    getStopDetailTop100CompanyDecrypt({
                                          id
                                      }) {
        return axios.get(
            `/bi-api/oilStationBerthCount/decrypt?id=${id}`
        )
    },
    getStopDetailTop100CompanyDecrypt2({
                                           id
                                       }) {
        return axios.get(
            `/bi-api/oilStationBerthCountV2/decrypt?id=${id}`
        )
    },
    //获取城市列表
    getCityList(option) {
        return axios.post(
            '/bi-api/vehicleway/cityList?time=' + new Date() * 1,
            option
        )
    },
    //入网车辆吨位，运营车辆吨位，里程，运营时间 城市级查询
    getCityDataList(option) {
        return axios.post(
            '/bi-api/freightVehicleCity/freightCityConditions?time=' + new Date() * 1,
            option
        )
    },
    // 加油站停靠导出
    carGasDowns({
                    // 加油站下载
                    yearMonths,
                    reqId,
                    provinceName,
                    timeType
                }) {
        return (
            `/bi-api/truckOil/exportTruck?timeType=${timeType}&countTime=${yearMonths}&reqId=${reqId}&provinceName=` +
            encodeURIComponent(provinceName)
        )
    },
    // provinceCode,
    // provinceName,
    // region,
    // oilBrand,
    // pathwayCityCode,
    // roadCode
    // 获取月份
    exportFreightDiscern({
                             year,
                             moduleName,
                             type,
                             provCodes,
                             region,
                             cityCodes,
                             countyCodes,
                             provCode,
                             cityCode,
                             countyCode,
                             tonnage
                         }) {
        return axios.get(
            `/bi-api/exportDiscern/exportFreightDiscern?year=${year}&moduleName=${moduleName}&type=${type}&provCodes=${provCodes}&cityCodes=${cityCodes}&countyCodes=${countyCodes}&provCode=${provCode}&cityCode=${cityCode}&countyCode=${countyCode}&tonnage=${tonnage}`
        )
    },
    exportFreightDiscern2({
                              year,
                              moduleName,
                              provinceCode,
                              provinceName,
                              region,
                              oilBrand,
                              pathwayCityCode,
                              roadCode
                          }) {
        return axios.get(
            `/bi-api/exportDiscern/exportFreightDiscern?year=${year}&moduleName=${moduleName}&provinceCode=${provinceCode}&provinceName=${provinceName}&region=${region}&oilBrand=${oilBrand}&pathwayCityCode=${pathwayCityCode}&roadCode=${roadCode}`
        )
    },
    exportFreightDiscern3({
                              year,
                              roadType,
                              dimension,
                              dateType
                          }) {
        return axios.get(
            `/bi-api/roadOperationStatistics/getMonthList?year=${year}&dateType=${dateType}&roadType=${roadType}&dimension=${dimension}`
        )
    },
    exportFreightDiscern4({
                              year,
                              roadType,
                              dimension
                          }) {
        // return axios.get(
        //     `/bi-api/roadOperationStatistics/getMonthList?year=${year}&roadType=${roadType}&dimension=${dimension}`
        // )
        return axios.get(`/bi-api/roadOperationStatisticsW/getweekList?year=${year}&roadType=${roadType}&dimension=${dimension}`)

    },
    // 获取月份
    exportFreightDiscern_fuelType({
                                      year,
                                      moduleName,
                                      provinceCode,
                                      provinceName,
                                      region,
                                      oilBrand,
                                      pathwayCityCode,
                                      roadCode,
                                      type,
                                      timeType
                                  }) {
        let url =
            `/bi-api/exportDiscern/exportFreightDiscernFuelType?type=${type}&year=${year}&moduleName=${moduleName}&provinceCode=${provinceCode}&provinceName=` +
            encodeURIComponent(provinceName) +
            `&region=` +
            encodeURIComponent(region) +
            `&brand=${oilBrand}&pathwayCityCode=${pathwayCityCode}&roadCode=` +
            encodeURIComponent(roadCode) +
            `&timeType=${timeType}`
        console.log('exportFreightDiscern_fuelType', url)
        return axios.get(url)
    },
    exportFreightDiscern_fuelTypeWuL({
                                         year,
                                         type,
                                         moduleName,
                                         tonnage,
                                         provCode,
                                         cityCode,
                                         countyCode,

                                     }) {
        let url =
            `/bi-api/exportDiscern/exportFreightDiscernFuelType?type=${type}&year=${year}&moduleName=${moduleName}&provCode=${provCode}&cityCode=${cityCode}&countyCode=${countyCode}&tonnage=${tonnage}`
        console.log('exportFreightDiscern_fuelType', url)
        return axios.get(url)
    },
    // 获取月份
    exportFreightDiscern_fuelType2({
                                       year,
                                       moduleName,
                                       provinceCode,
                                       provinceName,
                                       region,
                                       oilBrand,
                                       pathwayCityCode,
                                       roadCode,
                                       type
                                   }) {
        let url =
            `/bi-api/exportDiscern/exportFreightDiscernFuelTypeMS?type=${type}&year=${year}&moduleName=${moduleName}&provinceCode=${provinceCode}&provinceName=` +
            encodeURIComponent(provinceName) +
            `&region=` +
            encodeURIComponent(region) +
            `&brand=${oilBrand}&pathwayCityCode=${pathwayCityCode}&roadCode=` +
            encodeURIComponent(roadCode)
        console.log('exportFreightDiscern_fuelType', url)
        return axios.get(url)
    },
    // 获取月份
    exportFreightDiscern_fuelType23({
                                        year,
                                        moduleName,
                                        // provinceCode,
                                        // provinceName,
                                        // region,
                                        // oilBrand,
                                        // pathwayCityCode,
                                        // roadCode,
                                        type,
                                        stationType,
                                        tonnage,
                                        fuelType,
                                        provCode,
                                        cityCode,
                                        countyCode,
                                        provCodes,
                                        cityCodes,
                                        countyCodes,
                                    }) {

        let url =
            `/bi-api/exportDiscern/exportFreightDiscernFuelTypeMS?type=${type}&year=${year}&moduleName=${moduleName}&stationType=${stationType}&tonnage=${tonnage}&fuelType=${fuelType}&provCodes=${provCodes}&cityCodes=${cityCodes}&countyCodes=${countyCodes}&provCode=${provCode}&cityCode=${cityCode}&countyCode=${countyCode}`
        console.log('exportFreightDiscern_fuelType', url)
        return axios.get(url)
    },
    exportFreightDiscern_fuelType24({
                                        year,
                                        moduleName,
                                        // provinceCode,
                                        // provinceName,
                                        // region,
                                        // oilBrand,
                                        // pathwayCityCode,
                                        // roadCode,
                                        type,
                                        stationType,
                                        tonnage,
                                        fuelType,
                                        provCode,
                                        cityCode,
                                        countyCode,
                                    }) {

        let url =
            `/bi-api/exportDiscern/exportFreightDiscernFuelTypeMS?type=${type}&year=${year}&moduleName=${moduleName}&stationType=${stationType}&tonnage=${tonnage}&fuelType=${fuelType}&provCode=${provCode}`
        console.log('exportFreightDiscern_fuelType', url)
        return axios.get(url)
    },
    // 途经各省道路里程统计  获取月份
    exportFreightDiscern_wayRoadType({year, type}) {
        return axios.post(`/bi-api/wayRoad/checkPeriod?year=${year}&type=${type}`)
    },
    //获取季度
    getSeasonData({year, moduleName}) {
        return axios.get(
            `/bi-api/exportSeason/Season?year=${year}&moduleName=${moduleName}`
        )
    },
    // 各省品牌加油站 企业详情查询
    exportCompanyExport: function ({
                                       yearMonths,
                                       reqId,
                                       provCode,
                                       cityCode,
                                       order,
                                       percentage
                                   }) {
        return `/bi-api/hYCompanyDetail/exportCompany?time=${yearMonths}&reqId=${reqId}&provCode=${provCode}&cityCode=${cityCode}&order=${order}&percentage=${percentage}`
    },
    // 各省品牌加油站 企业详情查询
    exportCompanyVehicle: function ({yearMonths, reqId, provName, companyName}) {
        return (
            `/bi-api/hYCompanyDetail/exportCompanyVehicle?time=${yearMonths}&reqId=${reqId}&provName=` +
            encodeURIComponent(provName) +
            `&companyname=` +
            encodeURIComponent(companyName)
        )
    },

    // 周日均运营车辆情况统计、周日均分品牌加油站停靠情况统计 查询“年-月-周”下，哪些周有数据
    getAllWeektool: function ({year}) {
        return axios.get(`/bi-api/tool/week/getAllWeek?year=${year}`)
    },
    getWeekDataDistribute: function ({year}) {
        return axios.get(`/bi-api/weekly_statistic/data_distribute?year=${year}`)
    },
    getWeekDataDistribute2: function ({year}) {
        return axios.get(`/bi-api/truckWuliuV2/exportTruckW/data_distribute?year=${year}`)
    },
    getWeekDataDistribute3: function ({year}) {
        return axios.get(`/bi-api/oilStationBerthCountV2/exportBerthW/data_distribute?year=${year}`)
    },
    getWeekDataDistribute4: function ({year}) {
        return axios.get(`/bi-api/oilStationBerthCountV2/exportWayProvinceW/data_distribute?year=${year}`)
    },
    getLatestWeekData: function () {
        return axios.get(`/bi-api/weekly_statistic/latest_week`)
    },
    getLatestWeekData2: function () {
        return axios.get(`/bi-api/truckWuliuV2/latest_week`)
    },
    latest_week: function ({dimension, roadType}) {
        return axios.get(`/bi-api/roadOperationStatisticsW/latest_week?dimension=${dimension}&roadType=${roadType}`)
    },
    getLatestWeekData3: function () {
        return axios.get(`/bi-api/oilStationBerthCountV2/latest_week`)
    },
    getLatestWeekData4: function () {
        return axios.get(`/bi-api/oilStationBerthCountV2/wayProvince/latest_week`)
    },
    getLastWeektool: function () {
        return axios.get(`/bi-api/collectAnalysis/getLastWeek`)
    },
    // 周日均运营车辆情况统计 查询周日均运营情况统计
    getWeekCarOperate: function ({provinceCode, year, month, week, type, cityCode}) {
        return axios.get(
            `/bi-api/weekly_statistic/car_operate?${
                provinceCode ? 'provinceCode=' + provinceCode + '&' : ''
            }year=${year}&month=${month}&week=${week}&type=${type}&cityCode=${cityCode}`
        )
    },
    // 周日均运营车辆情况统计 导出周日均运营情况统计
    getWeekCarOperateExport: function ({yearMonthWeeks, provinceCode, type, cityCode}) {
        return `/bi-api/weekly_statistic/car_operate_export?cityCode=${cityCode}&yearMonthWeeks=${yearMonthWeeks}&provinceCode=${provinceCode}&type=${type}&reqId=${+new Date()}`
    },
    getWeekCarOperateExport2: function ({yearMonthWeeks, provCityCounty, dunwei,sourceGastype,provCodes,
                                            cityCodes,
                                            countyCodes}) {
        return `/bi-api/truckWuliuV2/exportTruckW?&provCode=${provCityCounty[0] || ''}&cityCode=${provCityCounty[1] || ''}&countyCode=${provCityCounty[2] || ''}&provCodes=${provCodes}&cityCodes=${cityCodes}&countyCodes=${countyCodes}&countTime=${yearMonthWeeks}&reqId=${+new Date()}`
    },
    operateStatisticsExportW: function ({yearMonthWeeks, provCityCounty, roadType,sourceGastype,provCodes,
                                            cityCodes,
                                            countyCodes}) {
        console.log(provCityCounty)
        return `/bi-api/roadOperationStatisticsW/highway/operateStatisticsExportW?countTime=${yearMonthWeeks}&sourceGastype=${sourceGastype}&provincecode=${provCityCounty[0] || ''}&citycode=${provCityCounty[1] || ''}&countycode=${provCityCounty[2] || ''}&provCodes=${provCodes}&cityCodes=${cityCodes}&countyCodes=${countyCodes}&roadType=${roadType}&reqId=${+new Date()}`
    },
    addEnergyExportW: function ({yearMonthWeeks, provCityCounty, roadType,sourceGastype,provCodes,
                                    cityCodes,
                                    countyCodes,
                                    }) {
        return `/bi-api/roadOperationStatisticsW/highway/addEnergyExportW?countTime=${yearMonthWeeks}&roadType=${roadType}&sourceGastype=${sourceGastype}&provincecode=${provCityCounty[0] || ''}&citycode=${provCityCounty[1] || ''}&countycode=${provCityCounty[2] || ''}&provCodes=${provCodes}&cityCodes=${cityCodes}&countyCodes=${countyCodes}&reqId=${+new Date()}`
    },
    addEnergyStopInfoExportW: function ({yearMonthWeeks, provCityCounty, roadType,sourceGastype,provCodes,
                                    cityCodes,
                                    countyCodes,
                                    }) {
        return `/bi-api/roadOperationStatisticsW/addEnergyStopInfoExportW?countTime=${yearMonthWeeks}&sourceGastype=${sourceGastype}&provincecode=${provCityCounty[0] || ''}&citycode=${provCityCounty[1] || ''}&countycode=${provCityCounty[2] || ''}&provCodes=${provCodes}&cityCodes=${cityCodes}&countyCodes=${countyCodes}&roadType=${roadType}&reqId=${+new Date()}`
    },
    getWeekCarOperateExport3: function ({yearMonthWeeks, dunwei, zhanDianType, ranliaoType, sourceGastype}) {
        return `/bi-api/oilStationBerthCountV2/exportProvinceW?tonnage=${dunwei}&stationType=${zhanDianType}&fuelType=${ranliaoType}&sourceGastype=${sourceGastype}&time=${yearMonthWeeks}&reqId=${+new Date()}`
    },
    getWeekCarOperateExport4: function ({yearMonthWeeks, dunwei, zhanDianType, ranliaoType, provCode, sourceGastype}) {
        return `/bi-api/oilStationBerthCountV2/exportWayProvinceW?tonnage=${dunwei}&stationType=${zhanDianType}&fuelType=${ranliaoType}&provCode=${provCode}&sourceGastype=${sourceGastype}&time=${yearMonthWeeks}&reqId=${+new Date()}`
    },
    getWeekCarOperateExport5: function ({yearMonthWeeks, provCityCounty, dunwei, zhanDianType, ranliaoType, sourceGastype,provCodes,
                                            cityCodes,
                                            countyCodes}) {
        return `/bi-api/oilStationBerthCountV2/exportCountyW?tonnage=${dunwei}&provCode=${provCityCounty[0] || ''}&cityCode=${provCityCounty[1] || ''}&countyCode=${provCityCounty[2] || ''}&stationType=${zhanDianType}&fuelType=${ranliaoType}&sourceGastype=${sourceGastype}&provCodes=${provCodes || ''}&cityCodes=${cityCodes || ''}&countyCodes=${countyCodes || ''}&time=${yearMonthWeeks}&reqId=${+new Date()}`
    },
    getWeekCarOperateExport6: function ({
                                            yearMonthWeeks,
                                            provCityCounty,
                                            dunwei,
                                            zhanDianType,
                                            ranliaoType,
                                            sourceGastype,
                                            zhanDianBrand,
                                            provCodes,
                                            cityCodes,
                                            countyCodes,
                                        }) {
        return `/bi-api/oilStationBerthCountV2/exportOilStationBerthW?sourceGastype=${sourceGastype}&provCode=${provCityCounty[0] || ''}&cityCode=${provCityCounty[1] || ''}&countyCode=${provCityCounty[2] || ''}&provCodes=${provCodes || ''}&cityCodes=${cityCodes || ''}&countyCodes=${countyCodes || ''}&time=${yearMonthWeeks}&reqId=${+new Date()}`
    },
    // 周日均分品牌加油站停靠情况统计 查询周日均分品牌加油站停靠情况统计
    getWeekBrandStop: function ({provinceCode, year, month, week, type, cityCode}) {
        return axios.get(
            `/bi-api/weekly_statistic/brand_stop?${
                provinceCode ? 'provinceCode=' + provinceCode + '&' : ''
            }year=${year}&month=${month}&week=${week}&type=${type}&cityCode=${cityCode}`
        )
    },
    // 周日均分品牌加油站停靠情况统计 导出周日均分品牌加油站停靠情况统计
    getWeekBrandStopExport: function ({yearMonthWeeks, provinceCode, type, cityCode}) {
        return `/bi-api/weekly_statistic/brand_stop_export?cityCode=${cityCode}&yearMonthWeeks=${yearMonthWeeks}&provinceCode=${provinceCode}&type=${type}&reqId=${+new Date()}`
    },
    // 数据源配置测算接口
    calculation(option) {
        return axios.post(
            '/bi-api/customersSetting/calculation?time=' + new Date() * 1,
            option
        )
    },
    // 数据源配置立即执行接口
    execute(option) {
        return axios.post(
            '/bi-api/customersSetting/execute?time=' + new Date() * 1,
            option
        )
    },
    // 数据源配置历史记录接口
    findRecordPage(option) {
        return axios.post(
            '/bi-api/customersSetting/findRecordPage?time=' + new Date() * 1,
            option
        )
    }
}
